export default __webpack_public_path__ + "static/media/icon_camera.b2ce84b2.svg";